export const ru = {
    'empty-header': 'Нет стартовых фраз',
    'empty-text': 'Добавьте стартовые фразы',
    'error-header': 'Не удалось загрузить фразы'
};
